module.exports = __webpack_public_path__ + "img/profile_active.19c99178.svg";